import { NgModule } from '@angular/core';
import { Route } from '@angular/router';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [],
})
export class ReportDetailsModule {
    static defineRoute(path: string): Route {
        return {
            path,
            loadChildren: () =>
                import('app/report-details/report-details.lazy.module').then(
                    (m) => m.ReportDetailsLazyLoadedModule,
                ),
        };
    }
}
